import { BaseEntity } from './base.entity';

export interface FirestoreTimestamp {
  seconds: number;
  nanoseconds: number;
}

export class TimeSheetEntity extends BaseEntity {
  public billableItem: string;
  public project?: string = '';
  public card: string;
  public boardKey: string;
  public item: string;
  public notes: string;
  public from: string;
  public to: string;
  public total: number;
  public date: number;
  public calendarId: string;
  public userKey: string;
  [key: string]: any;

  constructor() {
    super();
    this.billableItem = '';
    this.card = '';
    this.boardKey = '';
    this.item = '';
    this.notes = '';
    this.from = '';
    this.to = '';
    this.total = 0;
    this.date = 0;
    this.userKey = '';
    this.calendarId = '';
  }
}
